import { render, staticRenderFns } from "./DocumentDropzone.vue?vue&type=template&id=feaf71b2&"
import script from "./DocumentDropzone.vue?vue&type=script&lang=js&"
export * from "./DocumentDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports